import React from 'react';
import { Card } from '@material-ui/core';
import CustomerSubscriptionsTable from './CustomerSubscriptionsTable';


const CustomerSubscriptions = ({customerId}) => {
  return (
    <Card elevation={20}>
      <CustomerSubscriptionsTable customerId={customerId} />
    </Card>
  );
};

export default CustomerSubscriptions;
